import React, { useEffect } from 'react';
import { SectionWrapper } from './SectionWrapper';
import { GraduationCap } from 'lucide-react';

const SecondaryCTA: React.FC = () => {
  useEffect(() => {
    // Load HubSpot Script
    const script = document.createElement('script');
    script.src = '//js-eu1.hsforms.net/forms/embed/v2.js';
    script.charset = 'utf-8';
    script.type = 'text/javascript';
    script.async = true;

    script.onload = () => {
      // @ts-ignore
      if (window.hbspt) {
        // @ts-ignore
        window.hbspt.forms.create({
          portalId: "147631815",
          formId: "31d96d14-e5c8-4afa-8223-0617d0a642bb",
          region: "eu1",
          target: "#hubspot-briefing-form"
        });
      }
    };

    document.body.appendChild(script);

    return () => {
      const hsScript = document.querySelector('script[src="//js-eu1.hsforms.net/forms/embed/v2.js"]');
      if (hsScript) {
        document.body.removeChild(hsScript);
      }
    };
  }, []);

  return (
    <div className="bg-accent border-t border-divider py-12">
        <SectionWrapper className="py-20">
            <div className="bg-white rounded-[2.5rem] border border-divider p-8 md:p-20 text-center max-w-4xl mx-auto shadow-2xl relative overflow-hidden">
                <div className="absolute top-0 left-0 w-2 h-full bg-accent"></div>
                
                <div className="w-16 h-16 bg-accent/10 rounded-2xl flex items-center justify-center mx-auto mb-8">
                    < GraduationCap className="w-8 h-8 text-accent" />
                </div>

                <h2 className="text-3xl md:text-4xl font-black mb-6 text-primary tracking-tight">
                    Experten-Briefing: Wollen Sie Ihr Projektteam fit machen?
                </h2>
                
                <div className="text-gray-600 space-y-6 mb-12 max-w-2xl mx-auto text-lg leading-relaxed">
                    <p className="font-bold text-primary">Leitfäden sind gut, geschultes Personal ist besser.</p>
                    <p>
                        Wir bieten Ihnen eine <span className="text-accent font-bold italic">30-Minuten-Impuls-Schulung</span> an (Online oder vor Ort) mit minimalem Zeitaufwand. Wir zeigen Ihren Projektleitern kompakt:
                    </p>
                    
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-left text-sm font-semibold mb-12">
                        <div className="bg-surface p-4 rounded-xl border border-divider">
                            <span className="text-accent block mb-1">01. Planung</span>
                            Wie man Staubschutz-Massnahmen SIA-kompatibel plant.
                        </div>
                        <div className="bg-surface p-4 rounded-xl border border-divider">
                            <span className="text-accent block mb-1">02. Schutz</span>
                            Wie aktive Kühlung während der Arbeiten gesichert bleibt.
                        </div>
                        <div className="bg-surface p-4 rounded-xl border border-divider">
                            <span className="text-accent block mb-1">03. Prävention</span>
                            Wie Sie teuren Haftungsfällen und Baustopps vorbeugen.
                        </div>
                    </div>
                </div>

                <div className="text-left max-w-2xl mx-auto bg-surface p-8 rounded-2xl border border-divider shadow-inner relative min-h-[400px]">
                    <div id="hubspot-briefing-form" className="hubspot-form-wrapper">
                        <div className="flex flex-col items-center justify-center py-12 text-accent/30 animate-pulse">
                            <div className="w-10 h-10 border-3 border-accent/20 border-t-accent rounded-full animate-spin mb-4"></div>
                            <p className="text-sm font-bold uppercase tracking-widest">Anfrage-Formular lädt...</p>
                        </div>
                    </div>
                </div>
            </div>
        </SectionWrapper>

        <style>{`
            .hubspot-form-wrapper form {
                background: transparent !important;
                display: flex !important;
                flex-direction: column !important;
                gap: 0 !important;
            }

            .hubspot-form-wrapper .hs-form-field {
                margin-bottom: 1.25rem !important;
            }

            .hubspot-form-wrapper label {
                color: #474747 !important;
                font-size: 13px !important;
                font-weight: 700 !important;
                margin-bottom: 8px !important;
                display: block !important;
            }

            .hubspot-form-wrapper input[type="text"],
            .hubspot-form-wrapper input[type="email"],
            .hubspot-form-wrapper input[type="tel"],
            .hubspot-form-wrapper select,
            .hubspot-form-wrapper textarea {
                width: 100% !important;
                padding: 0.85rem 1rem !important;
                border-radius: 0.75rem !important;
                border: 1px solid #E5E7EB !important;
                background: #FFFFFF !important;
                font-size: 15px !important;
                transition: all 0.2s !important;
                outline: none !important;
            }

            .hubspot-form-wrapper input:focus {
                border-color: #487274 !important;
                box-shadow: 0 0 0 3px rgba(72, 114, 116, 0.1) !important;
            }

            .hubspot-form-wrapper .hs-button {
                background: #487274 !important;
                color: #FFFFFF !important;
                border-radius: 0.75rem !important;
                font-weight: 800 !important;
                font-size: 16px !important;
                padding: 1.2rem !important;
                width: 100% !important;
                border: none !important;
                cursor: pointer !important;
                transition: all 0.2s !important;
                margin-top: 1rem !important;
                box-shadow: 0 4px 12px rgba(72, 114, 116, 0.2) !important;
            }

            .hubspot-form-wrapper .hs-button:hover {
                background: #3A5C5E !important;
                transform: translateY(-1px) !important;
                box-shadow: 0 6px 15px rgba(72, 114, 116, 0.25) !important;
            }
            
            .hubspot-form-wrapper .hs-error-msgs label {
                color: #dc2626 !important;
                font-size: 12px !important;
                margin-top: 4px !important;
                font-weight: 500 !important;
            }
            
            /* Hide HubSpot Branding if possible via CSS */
            .hs-main-font-element {
                font-family: 'Inter', sans-serif !important;
            }
        `}</style>
    </div>
  );
};

export default SecondaryCTA;